import React from "react";
import RegistrationContainer from "../../containers/Registration/RegistrationContainer";
import { MainContainer } from "../../helpers/StyledComponents";
import { Helmet } from "react-helmet";

const Registration = () => {
  return (
    <>
      <Helmet>
        <title>สมัครสมาชิก - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <MainContainer>
        <RegistrationContainer />
      </MainContainer>
    </>
  );
};

export default Registration;
